/**
 * The workbench's layouts follow the width they have, not the screen's
 * (Mantine's `Grid type="container"`): the copilot's column may stand
 * beside them. The breakpoints are the screen's, less the app's navigation.
 */
export const CONTAINER_BREAKPOINTS = {
  xs: '30em',
  sm: '40em',
  md: '50em',
  lg: '60em',
  xl: '75em',
};

/** Wide enough for the review's margin beside a draft (pixels). */
export const MARGIN_WIDTH = 900;
